import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-937e58aa")

_pushScopeId("data-v-937e58aa")
const _hoisted_1 = {
  key: 0,
  class: "caption-button-container player-adon"
}
const _hoisted_2 = { class: "caption-button-list-flex" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    class: "play-arrow"
  }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }),
    /*#__PURE__*/_createVNode("path", { d: "M8 5v14l11-7z" })
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.isPosterVisible.value)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.posterCaptions, (c, i) => {
            return (_openBlock(), _createBlock("button", {
              type: "button",
              role: "button",
              "aria-label": `${_ctx.getLanguageString(c.language)}`,
              class: "caption-play-buttons",
              key: i,
              onClick: ($event: any) => (_ctx.clickCaption(c.language ? c.language : `en`, true))
            }, [
              _hoisted_3,
              _createTextVNode(_toDisplayString(c.language ? _ctx.getLanguageString(c.language) : "English"), 1)
            ], 8, ["aria-label", "onClick"]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
})